module.exports = __webpack_public_path__ + "static/media/change_status_1.108fbc26.png";